"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const alert_1 = require("components/cosmos/alert");
const button_1 = __importDefault(require("components/cosmos/button/button"));
const Html_1 = __importDefault(require("components/Html"));
const Survicate_1 = require("configs/Survicate");
const translationContext_1 = require("configs/translationContext");
const useModal_1 = require("hooks/useModal");
const newClubAdoptionEvents_1 = require("./newClubAdoptionEvents");
const newClubAdoptionModal_1 = __importDefault(require("./newClubAdoptionModal"));
const STORAGE_BASE_KEY = 'newClubAdoptionCtaClosed';
const NewClubAdoptionCta = ({ isMobile, userId, productId }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    const storageKey = `${STORAGE_BASE_KEY}:${productId}`;
    const [shouldRenderAlert, setShouldRenderAlert] = (0, react_1.useState)(() => {
        const storageData = sessionStorage.getItem(storageKey);
        return storageData !== 'true';
    });
    const [showAlert, setShowAlert] = (0, react_1.useState)(true);
    const { handleOpen, handleClose, isModalOpen } = (0, useModal_1.useModal)();
    const handleUpdateClick = () => {
        (0, newClubAdoptionEvents_1.sendEvent)('ClickUpdateTemplate', { userId });
        handleOpen();
    };
    const handleLeaveClick = () => {
        setShowAlert(false);
        setShouldRenderAlert(false);
        (0, Survicate_1.showSurvey)(Survicate_1.SURVEY_ID_LIST.SURVEY_NON_ADOPTION_NEW_CLUB);
        (0, newClubAdoptionEvents_1.sendEvent)('ClickNonAdoptionNewClub', { userId });
        sessionStorage.setItem(storageKey, String(true));
    };
    if (!showAlert || !shouldRenderAlert) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(alert_1.Alert, { type: "warning", dismissible: true, className: "_mb-6 _d-flex _align-content-start", children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'exclamation-triangle'], className: "_mr-3 _w-5 _h-5 _text-gray-900" }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(Html_1.default, { tag: "p", className: "_my-0", children: t('new_club_adoption.banner.description') }), (0, jsx_runtime_1.jsx)(button_1.default, { className: "_mt-4 _mr-4", variation: "info", onClick: handleUpdateClick, ...(isMobile && { size: 'block' }), children: t('new_club_adoption.banner.action.update') }), (0, jsx_runtime_1.jsx)(button_1.default, { className: "_mt-4", variation: "tertiary", onClick: handleLeaveClick, ...(isMobile && { size: 'block' }), children: t('new_club_adoption.banner.action.leave') })] })] }), isModalOpen && ((0, jsx_runtime_1.jsx)(newClubAdoptionModal_1.default, { onClose: handleClose, isMobile: isMobile, userId: Number(userId) }))] }));
};
exports.default = NewClubAdoptionCta;
